<template>
   <div id="wrapper" class="wrapper-auth">
      <div class="wrapper-auth-h-full" :class="{ 'represented-banner': isAccountRepBannerVisible }">
         <div class="wrapper-auth-bg">
            <div class="wrapper-auth-inner">
               <RouterView></RouterView>
            </div>
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/userStore";
const userStore = useUserStore();

// computed
// ---------------------------------------
// is the account representation banner showing, if so, we need to make some CSS changes
const isAccountRepBannerVisible = computed(() => {
   return userStore.isImpersonating || userStore.isAccountRepresented;
});
</script>

<style scoped lang="scss">
.wrapper-auth {
   display: flex;
   width: 100%;
   flex-direction: column;
   background-color: var(--white);
   font-family: var(--base-font-family);
}

.wrapper-auth-h-full {
   height: 100%;
   min-height: 100vh;
   overflow: hidden;

   &.represented-banner {
      padding-block-start: 2.625rem;
   }
}

.wrapper-auth-bg {
   min-height: 100vh;
   display: flex;
   justify-content: center;
   align-items: center;
   background-color: var(--colour-brand-background-light);
   color: var(--colour-brand-default);
}

.wrapper-auth-inner {
   margin: var(--size-base-80) 0;
   width: 100%;
   max-width: 30rem;
}
</style>
